define('shared/initializer/form/adapters/mixins/CrossDomainRetriever',[
    '$',
    'shared/lib/RSVP',
    'shared/lib/console',
    'shared/lib/store',
    'shared/util/state',
    'shared/util/state/adapters/form',
    'shared/util/state/adapters/order',
    'shared/util/state/adapters/page',
    'shared/util/state/adapters/session',
    'shared/util/state/adapters/tracking',
    'shared/util/state/adapters/pending',
    'shared/util/state/adapters/user'
],
function (
    $,
    RSVP,
    console,
    store,
    state,
    formAdapter,
    orderAdapter,
    pageAdapter,
    sessionAdapter,
    trackingAdapter,
    pendingAdapter,
    userAdapter
) {
    'use strict';

    var LOG_NAME = 'shared/initializer/form/adapters/mixins/DomainCrossable:';
    var KEY_STORE = 'cross-domain-transport';
    var afterCrossExecuted = false;
    var MAP_ALLOWED_STATE = {
        'session': true,
        'form': true
    };

    // TODO: for long run this method should be implemented into state adapters
    // so that it is available global-wise, however because the cross domain
    // requirement seems to be temporary, lets keep it here for now
    function handleAfterCrossed() {
        if (afterCrossExecuted) {
            return RSVP.resolve();
        }

        afterCrossExecuted = true;

        var data = store.get(KEY_STORE);

        if (data == null || data.purpose == null || data.purpose != 'domain-crossable') {
            return RSVP.resolve();
        }

        console.log(LOG_NAME, 'Extracting data from alien domain...');

        return RSVP.resolve()
            .then(function(){
                return RSVP.all([
                    state.adapters.add(formAdapter),
                    state.adapters.add(pageAdapter),
                    state.adapters.add(sessionAdapter),
                    state.adapters.add(trackingAdapter),
                    state.adapters.add(pendingAdapter),
                    state.adapters.add(userAdapter)
                ]);
            })
            .then(function(){

                var promises = [];
                var cur;

                for(var key in data.value) {
                    cur = data.value[key];
                    if (
                        cur == null ||
                        !(key in MAP_ALLOWED_STATE)
                    ) {
                        continue;
                    }
                    for(var subKey in cur) {
                        promises.push(
                            state.push(key + '.' + subKey, cur[subKey])
                        );
                    }
                }

                store.remove(KEY_STORE);

                return RSVP.all(promises);
            });
    }

    function Ctor() {

    }

    var p = Ctor.prototype;

    p.doPageLoad = function() {
        return handleAfterCrossed.call(this);
    };

    return Ctor;
});

